// Header.jsx
import React, {useRef, useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {NavLink, Link, useNavigate} from "react-router-dom";
import {useMediaQuery, IconButton, Drawer, Typography} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../../Assets/Svg/main-logo.svg";
import {useAuth} from "../../AuthContext/AuthContext";
import {useDispatch, useSelector} from "react-redux";
import {setProfileData} from "../../store/slices/profileSlice";
import {Styles} from "./styles";
import DashboardIcon from "./DashbaordIcon";
import DashboardIconLayout from "./DashbaordIconLayout";
import DefaultUserPhoto from "../../Assets/userphoto.png";
import CurrencyDropdown from "./CurrencyDropdown";
import NotificationsList from "./NotificationsList";
import UserProfilePopup from "./ProfilePopUp";
import MenuItems from "./MenuItems";
import {isLogin} from "../../tools/Helper";

const Header = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
    const dispatch = useDispatch();
    const profileData = useSelector((state) => state.profile.profileData);
    const user = JSON.parse(localStorage.getItem("user"));
    const navigate = useNavigate();
    const {logout} = useAuth();
    const [showProfile, setShowProfile] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const profileRef = useRef(null);
    const isMobile = useMediaQuery("(max-width:600px)");
    const [showNotifications, setShowNotifications] = useState(false);
    const [notifications, setNotifications] = useState([]);

    const handleLogout = async () => {
        setShowProfile(false);
        dispatch(setProfileData(null));
        logout();
    };

    const handleProfile = () => {
        setShowProfile(false);
        navigate("/profile");
    };

    const toggleProfile = () => {
        setShowProfile((prev) => !prev);
    };

    const handleDashboardClick = () => {
        navigate("/dashboard/overview");
    };

    const handleMenuItemClick = () => {
        setDrawerOpen(false); // Close the drawer
    };

    const handleClickOutside = (event) => {
        if (profileRef.current && !profileRef.current.contains(event.target)) {
            setShowProfile(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Resize listener to adjust responsiveness and close drawer when needed
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 600);
            if (drawerOpen && window.innerWidth >= 600) {
                setDrawerOpen(false);
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [drawerOpen]);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    return (
        <Styles>
            <Box
                sx={{
                    display: "flex",
                    gap: 1,
                    padding: 2,
                    borderRadius: "0 0 16px 16px",
                    boxShadow: "0px 4px 5px #00000040",
                    border: "2px solid #3F78E0",
                    minWidth: 0,
                }}
                className="main-container"
            >
                {/* Hamburger Menu for mobile */}
                <IconButton
                    onClick={toggleDrawer(true)}
                    sx={{
                        display: {xs: "block", md: "none"},
                        fontSize: "0",
                        marginBlock: "auto",
                        width: "40px",
                    }}
                >
                    <MenuIcon fontSize="large" style={{marginTop: "auto"}}/>
                </IconButton>

                {/* Logo and main links */}
                <Box
                    display="flex"
                    alignItems="center"
                    sx={{width: "calc(100% - 150px)", gap: {lg: "20px", md: "20px"}}}
                >
                    <Link
                        to="/home"
                        style={{cursor: "pointer", height: "56px"}}
                        className="logo"
                    >
                        <img
                            src={Logo}
                            alt="Logo"
                            className="smallscreenlogo"
                            style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                            }}
                        />
                    </Link>
                    <Box
                        sx={{
                            display: {xs: "none", md: "flex"},
                            flexWrap: "nowrap",
                            overflowX: "auto",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                            width: isSmallScreen
                                ? "calc(100% - 120px)"
                                : "calc(100% - 180px)",
                            gap: {xs: "10px", sm: "20px", md: "20px"},
                            justifyContent: "flex-start",
                            marginRight: "10px",
                        }}
                        className="links-container"
                    >
                        <NavLink
                            to="/"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Service Finder
                        </NavLink>
                        {/*<NavLink*/}
                        {/*  to="/Providers"*/}
                        {/*  className="item"*/}
                        {/*  activeclassname="active"*/}
                        {/*  style={{*/}
                        {/*    whiteSpace: "nowrap",*/}
                        {/*    overflow: "hidden",*/}
                        {/*    textOverflow: "ellipsis",*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  Providers*/}
                        {/*</NavLink>*/}
                        <NavLink
                            to="/OurServices"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Our services
                        </NavLink>
                        {/*<NavLink*/}
                        {/*  to="/OurOffers"*/}
                        {/*  className="item"*/}
                        {/*  activeclassname="active"*/}
                        {/*  style={{*/}
                        {/*    whiteSpace: "nowrap",*/}
                        {/*    overflow: "hidden",*/}
                        {/*    textOverflow: "ellipsis",*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  Our offers*/}
                        {/*</NavLink>*/}
                        <NavLink
                            to="/WhatsappGroups"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Whatsapp Groups
                        </NavLink>
                        <NavLink
                            to="/TelegramGroups"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Telegram Groups
                        </NavLink>
                        <NavLink
                            to="/SkypeGroups"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Skype Groups
                        </NavLink>

                        <NavLink
                            to="/ads"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Ads
                        </NavLink>


                        <NavLink
                            to="/Panels"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Panels
                        </NavLink>
                        <NavLink
                            to="/AddPanel"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Add Panel
                        </NavLink>
                        <NavLink
                            to="/Team"
                            className="item"
                            activeclassname="active"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            Our Team
                        </NavLink>
                        {/*<NavLink*/}
                        {/*  to="/Terms"*/}
                        {/*  className="item"*/}
                        {/*  activeclassname="active"*/}
                        {/*  style={{*/}
                        {/*    whiteSpace: "nowrap",*/}
                        {/*    overflow: "hidden",*/}
                        {/*    textOverflow: "ellipsis",*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  Terms*/}
                        {/*</NavLink>*/}
                    </Box>
                </Box>

                {/* Right side buttons */}
                <Box display="flex" alignItems="center" sx={{flexWrap: "nowrap"}}>
                    {isSmallScreen ? (
                        isLogin ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "10px",
                                    alignItems: "center",
                                    flexShrink: 1,
                                    minWidth: 0,
                                }}
                            >
                                <NotificationsList
                                    showNotifications={showNotifications}
                                    toggleNotifications={() =>
                                        setShowNotifications((prev) => !prev)
                                    }
                                    notifications={notifications}
                                    handleClickAway={() => setShowNotifications(false)}
                                    profileData={profileData}
                                />
                                <DashboardIconLayout
                                    onClick={handleDashboardClick}
                                    ariaLabel="Dashboard"
                                >
                                    <DashboardIcon/>
                                </DashboardIconLayout>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#3F78E0",
                                        color: "#F1F5FD",
                                        borderRadius: "8px",
                                        padding: "6px 12px",
                                        minWidth: "auto",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        textTransform: "capitalize",
                                    }}
                                    onClick={() => navigate("/post-ad")}
                                >
                                    Post
                                </Button>
                                <CurrencyDropdown/>
                            </Box>
                        ) : (
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#3F78E0",
                                    color: "#F1F5FD",
                                    borderRadius: "12px",
                                    "&:hover": {backgroundColor: "#355dab"},
                                    border: "2px solid #3F78E0",
                                    display: "flex",
                                    gap: "10px",
                                    padding: "10px 12px",
                                    boxShadow: "0px 4px 4px #00000040",
                                }}
                                onClick={() => navigate("/signup")}
                            >
                                <Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: "500",
                                        fontSize: "16px",
                                        color: "#F1F5FD",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Sign up
                                </Typography>
                                <svg
                                    className="sign-up-arrow"
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11.2441 2.8457H14.0653C14.4394 2.8457 14.7982 2.99432 15.0627 3.25885C15.3273 3.52339 15.4759 3.88218 15.4759 4.25629V14.1304C15.4759 14.5045 15.3273 14.8633 15.0627 15.1278C14.7982 15.3924 14.4394 15.541 14.0653 15.541H11.2441"
                                        stroke="white"
                                        strokeWidth="1.41059"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.7168 12.7199L11.2433 9.19346L7.7168 5.66699"
                                        stroke="white"
                                        strokeWidth="1.41059"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11.2428 9.19336H2.7793"
                                        stroke="white"
                                        strokeWidth="1.41059"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Button>
                        )
                    ) : isLogin ? (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "30px",
                                alignItems: "center",
                                position: "relative",
                                flexShrink: 1,
                                minWidth: 0,
                            }}
                        >
                            <NotificationsList
                                showNotifications={showNotifications}
                                toggleNotifications={() =>
                                    setShowNotifications((prev) => !prev)
                                }
                                notifications={notifications}
                                handleClickAway={() => setShowNotifications(false)}
                                profileData={profileData}
                            />
                            <Box>
                                <DashboardIconLayout
                                    onClick={handleDashboardClick}
                                    ariaLabel="Dashboard"
                                    showText={true}
                                >
                                    <DashboardIcon/>
                                </DashboardIconLayout>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#3F78E0",
                                    color: "#F1F5FD",
                                    borderRadius: "20px",
                                    padding: "8px 20px",
                                    "&:hover": {backgroundColor: "#355dab"},
                                    textTransform: "capitalize",
                                    fontWeight: 600,
                                }}
                                onClick={() => navigate("/post-ad")}
                            >
                                Post
                            </Button>
                            {isLogin && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: "30px",
                                        position: "relative",
                                        flexShrink: 1,
                                        minWidth: 0,
                                    }}
                                >
                                    <img
                                        src={profileData?.photo || DefaultUserPhoto}
                                        alt="User"
                                        style={{
                                            border: "1px solid #296D99",
                                            borderRadius: "50%",
                                            cursor: "pointer",
                                            width: "40px",
                                            height: "40px",
                                        }}
                                        onClick={toggleProfile}
                                    />
                                    {showProfile && (
                                        <UserProfilePopup
                                            userPhoto={profileData?.photo}
                                            userName={profileData?.name}
                                            userEmail={profileData?.email}
                                            onLogout={handleLogout}
                                            onProfileClick={handleProfile}
                                            profileRef={profileRef}
                                            DefaultUserPhoto={DefaultUserPhoto}
                                        />
                                    )}
                                </Box>
                            )}
                            <Box sx={{flexShrink: 1, minWidth: 0}}>
                                <CurrencyDropdown/>
                            </Box>
                        </Box>
                    ) : (
                        <Box
                            display="flex"
                            flexDirection="row"
                            gap="15px"
                            alignItems="center"
                            sx={{flexShrink: 1, minWidth: 0}}
                        >
                            {/* Sign Up Button */}
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#3F78E0",
                                    color: "#F1F5FD",
                                    borderRadius: "8px",
                                    "&:hover": {
                                        backgroundColor: "#355dab",
                                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                                    },
                                    border: "2px solid #3F78E0",
                                    display: {xs: "none", md: "flex"},
                                    gap: "8px",
                                    padding: "8px 20px",
                                    minHeight: "40px",
                                    alignItems: "center",
                                    transition: "all 0.2s ease",
                                }}
                                onClick={() => navigate("/signup")}
                            >
                                <Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: "600",
                                        fontSize: "15px",
                                        lineHeight: 1.2,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    Sign up
                                </Typography>
                                <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    style={{flexShrink: 0}}
                                >
                                    <path
                                        d="M11.2441 2.8457H14.0653C14.4394 2.8457 14.7982 2.99432 15.0627 3.25885C15.3273 3.52339 15.4759 3.88218 15.4759 4.25629V14.1304C15.4759 14.5045 15.3273 14.8633 15.0627 15.1278C14.7982 15.3924 14.4394 15.541 14.0653 15.541H11.2441"
                                        stroke="white"
                                        strokeWidth="1.41059"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M7.7168 12.7199L11.2433 9.19346L7.7168 5.66699"
                                        stroke="white"
                                        strokeWidth="1.41059"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M11.2428 9.19336H2.7793"
                                        stroke="white"
                                        strokeWidth="1.41059"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Button>

                            {/* Sign In Button */}
                            <Button
                                variant="outlined"
                                sx={{
                                    color: "#3F78E0",
                                    borderRadius: "8px",
                                    "&:hover": {
                                        backgroundColor: "#3F78E0",
                                        color: "#F1F5FD",
                                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                                    },
                                    border: "2px solid #3F78E0",
                                    display: {xs: "none", md: "flex"},
                                    padding: "8px 20px",
                                    minHeight: "40px",
                                    alignItems: "center",
                                    transition: "all 0.2s ease",
                                    backgroundColor: "transparent",
                                }}
                                onClick={() => navigate("/login")}
                            >
                                <Typography
                                    sx={{
                                        whiteSpace: "nowrap",
                                        textTransform: "capitalize",
                                        fontWeight: "600",
                                        fontSize: "15px",
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Sign In
                                </Typography>
                            </Button>
                            <Box sx={{flexShrink: 1, minWidth: 0}}>
                                <CurrencyDropdown/>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>

            {/* Drawer for mobile navigation */}
            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
                <MenuItems
                    isMobile={isMobile}
                    isSmallScreen={isSmallScreen}
                    navigate={navigate}
                    showNotifications={showNotifications}
                    toggleNotifications={() => setShowNotifications((prev) => !prev)}
                    notifications={notifications}
                    showProfile={showProfile}
                    toggleProfile={toggleProfile}
                    handleLogout={handleLogout}
                    handleProfile={handleProfile}
                    profileRef={profileRef}
                    setShowNotifications={setShowNotifications}
                    userphoto={profileData?.photo}
                    name={profileData?.name}
                    handleDashboardClick={handleDashboardClick}
                    onLogout={handleLogout}
                    DefaultUserPhoto={DefaultUserPhoto}
                    onCloseDrawer={handleMenuItemClick}
                />
            </Drawer>
        </Styles>
    );
};

export default Header;
